export const FEATURES: string[] = [
    // "dashboard_library_month-overview",
    // "dashboard_library_hours-distribution",
    // "dashboard_library_report-progress",
    // "dashboard_library_calendar-schedule",
];
